"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeaturedTemplateThumbnail = void 0;
var react_1 = __importDefault(require("react"));
var BemBuilder_1 = __importDefault(require("@CommonFrontend/Utils/BemBuilder"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var c = (0, BemBuilder_1.default)("featured-template-thumbnail");
var FeaturedTemplateThumbnail = function (_a) {
    var template = _a.template, onClick = _a.onClick;
    var image = template.featuredTemplate.image;
    var name = template.featuredTemplate.name;
    if (!/\.(jpg|png)$/i.test(image)) {
        image += ".jpg";
    }
    var imageLink = !!image
        ? "/Assets/Images/templates/thumbnails/".concat(image)
        : "/Assets/Images/templates/thumbnails/template-empty.png";
    return (react_1.default.createElement(kaleidoscope_1.ButtonCard, { className: c(), elevation: 1, onClick: onClick },
        react_1.default.createElement("img", { className: c("img"), src: imageLink, alt: name }),
        react_1.default.createElement("div", { className: c("caption") },
            react_1.default.createElement(kaleidoscope_1.Text, { size: "s" }, name))));
};
exports.FeaturedTemplateThumbnail = FeaturedTemplateThumbnail;
